import * as React from 'react';
import Svg, { SvgProps, Path, Circle } from 'react-native-svg';
import Colors from '../../constants/Colors';

interface Props extends SvgProps {
  add?: boolean;
}

const NotificationIcon = (props: Props) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    d='M18 8.00061C18 6.40931 17.3679 4.88319 16.2426 3.75797C15.1174 2.63275 13.5913 2.00061 12 2.00061C10.4087 2.00061 8.88258 2.63275 7.75736 3.75797C6.63214 4.88319 6 6.40931 6 8.00061C6 15.0006 3 17.0006 3 17.0006H21C21 17.0006 18 15.0006 18 8.00061Z'
    stroke={props.color ?? Colors.light.hereworksBlue500}
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M13.7305 21C13.5547 21.3031 13.3023 21.5547 12.9987 21.7295C12.6951 21.9044 12.3509 21.9965 12.0005 21.9965C11.6501 21.9965 11.3059 21.9044 11.0023 21.7295C10.6987 21.5547 10.4463 21.3031 10.2705 21'
    stroke={props.color ?? Colors.light.hereworksBlue500}
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Circle
    cx='17'
    cy='6'
    r='3.5'
    fill='#ED364C'
    stroke='white'
  />
</Svg>;

export default NotificationIcon;
